import { Controller } from "@hotwired/stimulus"
import { getMetaValue } from "../helpers/application_helper";

// Connects to data-controller="autosave"
export default class extends Controller {
  connect() {
  }

  async saveValue(event){
    const form = this.element;
    const headers = { "X-CSRF-Token": getMetaValue("csrf-token") };
    const formData = new FormData(form);
    const request = { headers: headers, body: formData, method: 'PATCH'}
    const response = await fetch(form.action, request);
    console.log(response)
  }
}
